<template>
    <div class="m-2">
      <img :src="member.profileImg" alt="Avatar" class="rounded-full w-3/12 h-auto object-cover m-auto">
      <p class="text-md text-white text-center">{{ member.fullname }}</p>
    </div>
</template>

<script>
export default {
    name: 'Member',
    props: {
      member: {
        type: Object,
        required: true
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/credits/Member.vue